export const BOOKING_STATUSES = [
    'requested',
    'quoted',
    'confirmed',
    'completed',
    'no_show',
    'cancelled',
    'expired',
    'declined',
    // With a backup driver, waiting for them or for the rider; the request comes back if it goes nowhere.
    'referred',
    // The rider accepted the backup driver: a new booking under them took over from this one.
    'handed_off',
];
export const BOOKING_KINDS = ['fixed', 'custom', 'logged'];
/** Every allowed move. Anything not listed is refused. */
const TRANSITIONS = {
    requested: ['quoted', 'confirmed', 'cancelled', 'expired', 'declined', 'referred'],
    quoted: ['confirmed', 'cancelled', 'expired'],
    confirmed: ['completed', 'no_show', 'cancelled'],
    completed: [],
    no_show: [],
    cancelled: [],
    expired: [],
    declined: [],
    referred: ['requested', 'handed_off', 'cancelled', 'expired'],
    handed_off: [],
};
export function canTransition(from, to) {
    return TRANSITIONS[from].includes(to);
}
export const FINAL_STATUSES = ['completed', 'no_show', 'cancelled', 'expired', 'declined', 'handed_off'];
export const isFinal = (s) => FINAL_STATUSES.includes(s);
/** Statuses that occupy the driver's time on the calendar. */
export const BUSY_STATUSES = ['confirmed'];
const STATUS_LOOK = {
    requested: { label: 'Pending', tone: 'warn' },
    // The driver has said yes and named the price; the rider's answer makes it Confirmed.
    quoted: { label: 'Accepted', tone: 'info' },
    confirmed: { label: 'Confirmed', tone: 'ok' },
    completed: { label: 'Completed', tone: 'muted' },
    no_show: { label: 'No-show', tone: 'danger' },
    cancelled: { label: 'Cancelled', tone: 'muted' },
    expired: { label: 'Expired', tone: 'muted' },
    declined: { label: 'Declined', tone: 'muted' },
    referred: { label: 'Referred', tone: 'info' },
    handed_off: { label: 'Referred', tone: 'muted' },
};
/** The word and colour for a booking's status, the same on every screen on both sides. */
export function describeStatus(b) {
    // A card booking that is still `requested` is waiting for the rider's payment, not for the driver.
    if (b.status === 'requested' && b.paymentMode === 'card')
        return { label: 'Unpaid', tone: 'warn' };
    return STATUS_LOOK[b.status] ?? { label: b.status.replace(/_/g, ' '), tone: 'muted' };
}
//# sourceMappingURL=booking-state.js.map